import React, { useState } from 'react';
import Webcam from 'react-webcam';
import { Camera, RefreshCw, X, Settings, Image as ImageIcon, AlertCircle, Loader2 } from 'lucide-react';

const CameraView = ({
  webcamRef,
  devices,
  selectedDeviceId,
  cameraError,
  showSettings,
  setShowSettings,
  resolution,
  switchCamera,
  handleResolutionChange,
  handleDeviceSelect,
  capture,
  onCameraError,
  setRegMode,
  styles,
  onImageUpload,
  onCameraReady,
  editId
}) => {
  const [isCameraLoading, setIsCameraLoading] = useState(true);
  
  const videoConstraints = {
    deviceId: selectedDeviceId ? { exact: selectedDeviceId } : undefined,
    width: resolution === '4K' ? 3840 : resolution === 'FHD' ? 1920 : resolution === 'HD' ? 1280 : 640,
    height: resolution === '4K' ? 2160 : resolution === 'FHD' ? 1080 : resolution === 'HD' ? 720 : 480,
    facingMode: devices.length > 0 ? undefined : "environment" // Default to back camera
  };

  return (
    <div style={styles.cameraOverlay}>
      <div style={styles.cameraHeader}>
        <button onClick={() => { if (editId) { setRegMode('info'); } else { setRegMode('list'); } }} style={styles.iconBtn}>
          <X size={24} />
        </button>
        <span style={{fontSize: '16px', fontWeight: 'bold'}}>사진 촬영</span>
        <button onClick={() => setShowSettings(!showSettings)} style={styles.iconBtn}>
          <Settings size={24} />
        </button>
      </div>

      {showSettings && (
        <div style={styles.settingsPanel}>
          <h3 style={styles.settingsTitle}>카메라 설정</h3>
          
          <div style={styles.settingGroup}>
            <label style={styles.settingLabel}>카메라 선택</label>
            <select 
              value={selectedDeviceId || ''} 
              onChange={(e) => handleDeviceSelect(e.target.value)}
              style={styles.settingSelect}
            >
              {devices.length === 0 && <option value="">사용 가능한 카메라 없음</option>}
              {devices.map((device, key) => (
                <option key={key} value={device.deviceId}>
                  {device.label || `Camera ${key + 1}`}
                </option>
              ))}
            </select>
          </div>

          <div style={styles.settingGroup}>
            <label style={styles.settingLabel}>해상도</label>
            <div style={styles.resButtons}>
              {['VGA', 'HD', 'FHD', '4K'].map(res => (
                <button 
                  key={res}
                  onClick={() => handleResolutionChange(res)}
                  style={{
                    ...styles.resBtn,
                    backgroundColor: resolution === res ? '#0088FE' : '#333',
                    color: resolution === res ? '#fff' : '#ccc'
                  }}
                >
                  {res}
                </button>
              ))}
            </div>
          </div>

          <button onClick={() => setShowSettings(false)} style={styles.closeSettingsBtn}>
            닫기
          </button>
        </div>
      )}

      <div style={styles.webcamContainer}>
        {cameraError ? (
          <div style={styles.errorContainer}>
            <AlertCircle size={48} color="#ff4d4d" />
            <div style={styles.errorText}>{cameraError}</div>
            <button 
              onClick={() => window.location.reload()} 
              style={{...styles.actionBtn, marginTop: '20px', backgroundColor: '#444'}}
            >
              페이지 새로고침
            </button>
          </div>
        ) : (
          <>
            {isCameraLoading && (
              <div style={{...styles.errorContainer, position: 'absolute', zIndex: 5}}>
                <Loader2 size={48} className="animate-spin" style={{opacity: 0.5}} />
                <div style={{marginTop: '15px', color: '#888'}}>카메라를 불러오는 중...</div>
              </div>
            )}
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              style={{...styles.webcam, opacity: isCameraLoading ? 0 : 1}}
              onUserMedia={() => {
                setIsCameraLoading(false);
                if (onCameraReady) onCameraReady();
              }}
              onUserMediaError={(err) => {
                setIsCameraLoading(false);
                onCameraError(err);
              }}
              mirrored={false}
              playsInline={true}
            />
          </>
        )}
      </div>

      <div style={styles.cameraFooter}>
        <button onClick={() => document.getElementById('fileInput').click()} style={styles.iconBtn}>
           <ImageIcon size={24} />
           <input 
             id="fileInput" 
             type="file" 
             accept="image/*" 
             capture="environment"
             style={{display: 'none'}} 
             onChange={onImageUpload}
           />
        </button>
        
        <div 
          style={{
            ...styles.captureBtn, 
            opacity: isCameraLoading ? 0.5 : 1,
            pointerEvents: isCameraLoading ? 'none' : 'auto'
          }} 
          onClick={capture}
        >
          <div style={styles.captureBtnInner}></div>
        </div>

        <button onClick={switchCamera} style={styles.iconBtn}>
          <RefreshCw size={24} />
        </button>
      </div>
      <style>{`
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .animate-spin { animation: spin 1s linear infinite; }
      `}</style>
    </div>
  );
};

export default CameraView;
